import { Button } from '@/lib';
import { IModalContentProps } from '@/models/modals';
import { DataSourceFileConfig } from '@/models/dataSource';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ComuniList } from '../useComuniLists';

type ListMappingModalProps = { list: ComuniList } & IModalContentProps;

export const ListMappingModal: FC<ListMappingModalProps> = ({ list, closeModal }) => {
  const { t } = useTranslation('comuni');

  return (
    <div className='flex max-h-[70vh] w-full max-w-2xl flex-col gap-4 overflow-y-auto p-8'>
      <h3 className='text-lg font-semibold text-primary-900'>{t('lists.mappingTitle', { name: list.name })}</h3>
      {list.datasources.map((ds) => {
        const config = ds.configuration as DataSourceFileConfig;
        return (
          <div key={ds.id} className='overflow-hidden rounded-xl border'>
            <div className='grid grid-cols-2 gap-4 bg-secondary-background px-6 py-3 text-sm font-semibold text-quaternary-500'>
              <span>{t('lists.mappingColumn')}</span>
              <span>{t('lists.mappingTrait')}</span>
            </div>
            {(config.headers ?? []).map((header) => (
              <div key={header.name} className='grid grid-cols-2 gap-4 border-t px-6 py-3 text-sm text-tertiary-600'>
                <span className='font-medium text-primary-900'>{header.name}</span>
                <span>{header.skip ? t('lists.ignored') : header.displayName || header.traitId}</span>
              </div>
            ))}
          </div>
        );
      })}
      <div className='flex justify-end'>
        <Button intent='secondary' size='md' text={t('lists.close')} onClick={closeModal} />
      </div>
    </div>
  );
};
